import React, { useState, useEffect } from "react";
import Sidebar from "../components/sidebar";
import Card from "react-bootstrap/Card";
import axios from 'axios';
import SinPermisos from "./../components/sinpermisos";

const urlPost = "https://api.mrcirp.com/public/usuarios";

const Actualizardatosuser = () => {

  //////////////Datos de Usuario Logueado/////////////////////////
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const loginUserJSON = window.localStorage.getItem('loginUser')
    if (loginUserJSON) {
      const user = JSON.parse(loginUserJSON)
      setUsers(user);
    }
  }, []);

  console.log(users);

  ///////////////Insertar Datos//////////////////////////////////
  const [nuevoUsuario, setNuevoUsuario] = useState({
    nombre: '',
    descripcion: '',
    urlVideo: '',
    urlVideoProducto1: '',
    urlVideoProducto2: '',
    urlVideoProducto3: '',
    urlNegocio1: '',
    urlNegocio2: '',
    urlNegocio3: '',
    urlComoUnirseCliente: '',
    urlComoAfiliarse: '',
  });

  const [mensajeExito, setMensajeExito] = useState('');

  const handleChangeInsertar = e => {
    const { name, value } = e.target;
    setNuevoUsuario(prevState => ({
      ...prevState,
      [name]: value
    }))
  }

  const peticionPost = async () => {
    try {
      const datosCompletos = {
        ...nuevoUsuario,
        adminId: users.id,
        adminNombre: users.nombreuser
      };
      console.log(datosCompletos);
      const response = await axios.post(urlPost, datosCompletos);
      console.log(response.data);
      setMensajeExito('Usuario registrado con éxito');
      setNuevoUsuario({
        nombre: '',
        descripcion: '',
        urlVideo: '',
        urlVideoProducto1: '',
        urlVideoProducto2: '',
        urlVideoProducto3: '',
        urlNegocio1: '',
        urlNegocio2: '',
        urlNegocio3: '',
        urlComoUnirseCliente: '',
        urlComoAfiliarse: '',
      });
      // Manejar la respuesta si es necesario
    } catch (err) {
      console.error(err);
    }
  }


  const [Error, setError] = useState(false);

  /////////////////////////////////////////////////////////////////
  if (users.rol !== undefined) {
    if (users.rol === "cliente") {
      return (
        <div>
          <div className="Categorias">
            <Sidebar>
              <Card>
                <Card.Header className="bg-dark text-white" as="h3">
                  <div className='row'>
                    <div className='col-md-12'>
                      Actualizar datos
                    </div>
                  </div>
                </Card.Header>
                <Card.Body>
                  <Card.Title> Cliente</Card.Title>
                  {
                    Error &&
                    <div className="alert alert-danger">
                      {<strong>Error: El nombre ya existe! intente con otro nombre.</strong>}
                    </div>
                  }
                  {mensajeExito && (
                    <div className="alert alert-success">
                      {mensajeExito}
                    </div>
                  )}
                  <p>Registra tu usuario en la plataforma</p>
                  <div className="form-group">
                    <label><strong>Nombre para el enlace (www.ikimo.org/minombre)</strong></label>
                    <input
                      className="form-control"
                      type="text"
                      name="nombre"
                      value={nuevoUsuario.nombre}
                      onChange={handleChangeInsertar}
                    />
                    <br/> <br/>
                    <label><strong>Descripción del producto</strong></label>
                    <textarea
                      className="form-control"
                      name="descripcion"
                      value={nuevoUsuario.descripcion}
                      onChange={handleChangeInsertar}
                    />
                   <br/> <br/>
                    <label><strong>URL del video (Vimeo o YouTube)</strong></label>
                    <input
                      className="form-control"
                      type="text"
                      name="urlVideo"
                      value={nuevoUsuario.urlVideo}
                      onChange={handleChangeInsertar}
                    />
                    <br/> <br/>
                    <label><strong>URL video producto 1</strong></label>
                    <input
                      className="form-control"
                      type="text"
                      name="urlVideoProducto1"
                      value={nuevoUsuario.urlVideoProducto1}
                      onChange={handleChangeInsertar}
                    />
                    <br/> <br/>
                    <label><strong>URL video producto 2</strong></label>
                    <input
                      className="form-control"
                      type="text"
                      name="urlVideoProducto2"
                      value={nuevoUsuario.urlVideoProducto2}
                      onChange={handleChangeInsertar}
                    />
                    <br/> <br/>
                    <label><strong>URL video producto 3</strong></label>
                    <input
                      className="form-control"
                      type="text"
                      name="urlVideoProducto3"
                      value={nuevoUsuario.urlVideoProducto3}
                      onChange={handleChangeInsertar}
                    />
                     <br/> <br/>
                    <label><strong>URL como unirse como cliente</strong></label>
                    <input
                      className="form-control"
                      type="text"
                      name="urlComoUnirseCliente"
                      value={nuevoUsuario.urlComoUnirseCliente}
                      onChange={handleChangeInsertar}
                    />
                    <br/> <br/>
                    <label><strong>URL negocio 1</strong></label>
                    <input
                      className="form-control"
                      type="text"
                      name="urlNegocio1"
                      value={nuevoUsuario.urlNegocio1}
                      onChange={handleChangeInsertar}
                    />
                    <br/> <br/>
                    <label><strong>URL negocio 2</strong></label>
                    <input
                      className="form-control"
                      type="text"
                      name="urlNegocio2"
                      value={nuevoUsuario.urlNegocio2}
                      onChange={handleChangeInsertar}
                    />
                    <br/> <br/>
                    <label><strong>URL negocio 3</strong></label>
                    <input
                      className="form-control"
                      type="text"
                      name="urlNegocio3"
                      value={nuevoUsuario.urlNegocio3}
                      onChange={handleChangeInsertar}
                    />
                   
                    <br/> <br/>
                    <label><strong>URL como afiliarse</strong></label>
                    <input
                      className="form-control"
                      type="text"
                      name="urlComoAfiliarse"
                      value={nuevoUsuario.urlComoAfiliarse}
                      onChange={handleChangeInsertar}
                    />
                    <br/> <br/>
                    <button className="btn btn-success" onClick={() => peticionPost()}>
                      Registrar
                    </button>
                  </div>
                </Card.Body>
              </Card>
            </Sidebar>
          </div>
        </div>
      );
    }
    else {
      return (
        <div>
          <Sidebar>
            <SinPermisos />
          </Sidebar>
        </div>
      );
    }
  }
  else {
    return (
      <div>
        <Sidebar>
          <SinPermisos />
        </Sidebar>
      </div>
    );
  }
};

export default Actualizardatosuser;